import { render, staticRenderFns } from "./Awards.vue?vue&type=template&id=39c46fa1&scoped=true&"
import script from "./Awards.vue?vue&type=script&lang=ts&"
export * from "./Awards.vue?vue&type=script&lang=ts&"
import style0 from "./Awards.vue?vue&type=style&index=0&id=39c46fa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c46fa1",
  null
  
)

export default component.exports